import React from 'react'

const Temp = () => {
  return (
    <div>Temp</div>
  )
}

export default Temp